module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_minor/umi_dir-9258306fff57eef90aa69b55bec1dff2.gif";